import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { api, extractError } from "@/lib/api";

// Admin card to paste / replace / remove the Anthropic API key (stored encrypted server-side)
export function AnthropicKeyCard() {
    const [st, setSt] = useState(null);
    const [val, setVal] = useState("");
    const [busy, setBusy] = useState(false);
    const load = async () => { try { setSt((await api.get("/integrations/anthropic")).data); } catch (e) { toast.error(extractError(e)); } };
    useEffect(() => { load(); }, []);
    const save = async () => {
        setBusy(true);
        try { await api.put("/integrations/anthropic", { api_key: val }); setVal(""); toast.success("Chiave salvata"); load(); }
        catch (e) { toast.error(extractError(e)); }
        finally { setBusy(false); }
    };
    const remove = async () => {
        if (!window.confirm("Rimuovere la chiave? La Time Machine mostrerà solo l'elenco degli eventi.")) return;
        await api.delete("/integrations/anthropic"); load();
    };
    if (!st) return null;
    return (
        <div className="bg-white border border-neutral-200 rounded-md p-5 flex items-start gap-4" data-testid="integration-anthropic">
            <Sparkles size={20} className="text-neutral-500 mt-0.5" />
            <div className="flex-1 min-w-0 space-y-2">
                <div className="font-semibold text-sm">Resoconto AI (Anthropic)</div>
                <div className="text-xs text-neutral-500" data-testid="integration-anthropic-status">
                    {st.configured ? `Chiave configurata (…${st.last4}). Conservata cifrata sul server, mai visibile dal browser.` : "Nessuna chiave: la Time Machine mostra solo l'elenco cronologico, senza resoconto."}
                </div>
                <div className="flex gap-2">
                    <input type="password" value={val} onChange={(e) => setVal(e.target.value)} placeholder={st.configured ? "Incolla una nuova chiave per sostituirla" : "sk-ant-…"}
                        data-testid="anthropic-key-input" className="flex-1 text-sm border border-neutral-200 rounded-md px-3 py-1.5" />
                    <button onClick={save} disabled={busy || !val.trim()} data-testid="anthropic-key-save"
                        className="text-xs px-3 py-1.5 rounded-md bg-neutral-900 text-white disabled:opacity-40">{busy ? "Verifica…" : "Salva"}</button>
                    {st.configured && <button onClick={remove} data-testid="anthropic-key-remove" className="text-xs text-neutral-500 hover:text-red-600">Rimuovi</button>}
                </div>
            </div>
        </div>
    );
}
